import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducer from "./reducer";
import { createLogger } from "redux-logger";

const middleware = [];
middleware.push(thunk);

let composeEnhancers = compose;

if (process.env.NODE_ENV !== "production") {
  if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function") {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }
}

const loggerMiddleware = createLogger({
  predicate: () => process.env.NODE_ENV !== "production"
});
//middleware.push(loggerMiddleware);

const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
